import Vue from "vue";
import App from "./App";
import router from "./router";
import editor from "@tinymce/tinymce-vue";
import CoreuiVue from "@coreui/vue";
import "./main.css";
import { iconsSet as icons } from "./assets/icons/icons.js";
import { i18n } from "./plugins/i18n";
import VueCookies from "vue-cookies";
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue";
import VueMoment from "vue-moment";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import ToggleButton from "vue-js-toggle-button";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import VueEllipseProgress from "vue-ellipse-progress";
import { ColorPicker, ColorPanel } from "one-colorpicker";

const moment = require("moment");
require("moment/locale/th");
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "tinymce/tinymce";

// Theme
import "tinymce/themes/silver/theme";

// Skins
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

// Plugins
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/paste";
import "tinymce/plugins/autoresize";

import "babel-polyfill";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings as LuxonSettings } from "luxon";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

//Icon
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEyeSlash,
  faPowerOff,
  faUser,
  faStore,
  faBullhorn,
  faSearch,
  faFileUpload,
  faFilter,
  faSortDown,
  faPencilAlt,
  faTrashAlt,
  faTimes,
  faTimesCircle,
  faFileDownload,
  faEye,
  faBarcode,
  faPlus,
  faMinus,
  faStar,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faHome,
  faBuilding,
  faHotel,
  faCircle,
  faArrowRight,
  faClipboard,
  faBox,
  faSort,
  faHandHoldingUsd,
  faPlusCircle,
  faCheckCircle,
  faExclamationCircle,
  faEllipsisV,
  faCheck,
  faMapMarkerAlt,
  faMapMarkedAlt,
  faStickyNote,
  faShippingFast,
  faMoneyBillWave,
  faReceipt,
  faUserCheck,
  faUserPlus,
  faPercent,
  faRobot,
  faFileExport,
  faUserFriends,
  faCommentAlt,
  faSmile,
  faAngry,
  faMobileAlt,
  faWindowMaximize,
  faMap,
  faImage,
  faSave,
  faPlusSquare,
} from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarFar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  fab,
  faFacebookF,
  faInstagram,
  faLine,
  faTwitter,
  faApple,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
library.add(
  fab,
  faFacebookF,
  faInstagram,
  faLine,
  faTwitter,
  faApple,
  faYoutube
);
library.add(
  faEyeSlash,
  faUser,
  faPowerOff,
  faStore,
  faBullhorn,
  faSearch,
  faFilter,
  faFileUpload,
  faSortDown,
  faPencilAlt,
  faTrashAlt,
  faTimes,
  faTimesCircle,
  faFileDownload,
  faEye,
  faBarcode,
  faPlus,
  faMinus,
  faStar,
  faStarFar,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faHome,
  faBuilding,
  faHotel,
  faCircle,
  faArrowRight,
  faClipboard,
  faBox,
  faSort,
  faHandHoldingUsd,
  faPlusCircle,
  faCheckCircle,
  faExclamationCircle,
  faEllipsisV,
  faCheck,
  faMapMarkerAlt,
  faMapMarkedAlt,
  faStickyNote,
  faShippingFast,
  faMoneyBillWave,
  faReceipt,
  faUserCheck,
  faUserPlus,
  faPercent,
  faRobot,
  faFileExport,
  faUserFriends,
  faCommentAlt,
  faSmile,
  faAngry,
  faMobileAlt,
  faWindowMaximize,
  faMap,
  faImage,
  faSave,
  faPlusSquare
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueEllipseProgress);
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(VueAxios, axios);
Vue.use(vueNumeralFilterInstaller, { locale: "en-gb" });
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(ColorPanel);
Vue.use(ColorPicker);

Vue.use(ToggleButton);
Vue.use(Vuelidate);
import VueSlickCarousel from "vue-slick-carousel";
const Slick = {
  install(Vue) {
    Vue.component("slick", VueSlickCarousel);
  },
};

Vue.use(Slick);
Vue.use(VueMoment, {
  moment,
});
Vue.component("datetime", Datetime);
Vue.component("editor", editor);

let globalData = new Vue({
  data: {
    $isLoading: false,
    $campaignName: "",
  },
});

Vue.mixin({
  computed: {
    $isLoading: {
      get: function() {
        return globalData.$data.$isLoading;
      },
      set: function(isLoading) {
        globalData.$data.$isLoading = isLoading;
      },
    },
  },
});

// Choose MODE (INHOME, DEV , PROD )
const MODE = `${process.env.VUE_APP_MODE}`;
if (MODE == "PROD") {
  Vue.prototype.$baseUrl = "https://kerry-admin-api.d3-dots.com/api";
  Vue.prototype.$chatAgentWeb = "https://kerry-chat-agent.d3-dots.com";
  Vue.prototype.$chatBaseUrl =
    "https://kerry-chat-agent-api.d3-dots.com/api";
  Vue.prototype.$chatAPIKey = "lDd0T2cHa7s9sT3M";
  Vue.prototype.$facebookAppId = "1092526895305594";
  Vue.prototype.$facebookSecret = "479c4c74a3dea591e67dcae8f5c93343";
}

if (MODE == "UAT") {
  Vue.prototype.$baseUrl = "https://kerry-uat-admin-api.d3-dots.com/api";
  Vue.prototype.$chatAgentWeb = "https://kerry-uat-chat-agent.d3-dots.com";
  Vue.prototype.$chatBaseUrl =
    "https://kerry-uat-chat-agent-api.d3-dots.com/api";
  Vue.prototype.$chatAPIKey = "lDd0T2cHa7s9sT3M";
  Vue.prototype.$facebookAppId = "340612654090980";
  Vue.prototype.$facebookSecret = "a2e0115c7ee6342c89869852856ff3a9";
}

// if (MODE == "chat-agent") {
//   Vue.prototype.$baseUrl = " https://kerry-uat-admin-api.d3-dots.com/api";
// }

if (MODE == "DEV") {
  Vue.prototype.$baseUrl = "https://dev-kerry-admin-api.dosetech.co/api";
  Vue.prototype.$chatAgentWeb = "https://kerry-uat-chat-agent.d3-dots.com";
  Vue.prototype.$chatBaseUrl =
    "https://kerry-uat-chat-agent-api.d3-dots.com/api";
  Vue.prototype.$chatAPIKey = "lDd0T2cHa7s9sT3M";
}

Vue.prototype.$formatDate = "DD MMM YYYY";
Vue.prototype.$formatDateTime = "DD MMM YYYY (HH:mm)";
Vue.prototype.$formatTime = "HH:mm";

// API request
Vue.axios.interceptors.request.use(function(config) {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let brandID = params.brandID || 0;

  config.headers.Authorization = Vue.$cookies.isKey("admin-token")
    ? `Bearer ${Vue.$cookies.get("admin-token")}`
    : "null";

  config.headers.BrandID =
    store.getters.getCurrentBrandID() == null
      ? brandID
      : store.getters.getCurrentBrandID();
  return config;
});
// API response
Vue.axios.interceptors.response.use(
  function(response) {
    return Promise.resolve(response.data);
  },
  function(error) {
    if (error.response.status == 401) {
      Vue.$cookies.remove("admin-token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

LuxonSettings.defaultLocale = "th";

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!VueCookies.get("admin-token")) {
      next({
        path: "/login",
      });
    } else {
      if (to.name == "CHAT") {
        var myHeaders = new Headers();
        myHeaders.append("API-KEY", Vue.prototype.$chatAPIKey);
        myHeaders.append(
          "Authorization",
          "Bearer " + VueCookies.get("admin-token")
        );
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          token: VueCookies.get("admin-token"),
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(Vue.prototype.$chatBaseUrl + "/session/encode", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.result) {
              window.location =
                Vue.prototype.$chatAgentWeb +
                "/decode/" +
                result.detail.sessionId +
                `?brandID=${from.query.brandID}`;
            } else {
              window.location = `${from.path}?brandID=${from.query.brandID}`;
            }
          })
          .catch((error) => {
            console.log("error", error);
            window.location = `${from.path}?brandID=${from.query.brandID}`;
          });
        return;
      }
      if (!to.query.brandID) {
        if (from.query.brandID) {
          if (to.params.id) {
            next({
              name: to.name,
              query: { brandID: from.query.brandID, ...to.query },
              params: { id: to.params.id, ...to.params },
            });
          } else {
            next({
              name: to.name,
              query: { brandID: from.query.brandID, ...to.query },
            });
          }
          return;
        } else {
          next();
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some((record) => record.meta.requiresIsLogin)) {
    // logout from chat agent
    if (VueCookies.get("admin-token") && to.name == "Login") {
      if (from.fullPath == "/") {
        Vue.$cookies.remove("admin-token");
        next({
          path: "/login",
        });
      }
    }
    if (VueCookies.get("admin-token")) {
      next({
        path: "/",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({
  el: "#app",
  library,
  i18n,
  router,
  icons,
  store,
  template: "<App/>",
  components: {
    App,
  },
});
